<script setup lang="ts">
/**
 * Interim Dividends (B32113) — Dividend Voucher (주주 1인당 1부, mem_${id}/ 스코프).
 *   원본: Dividend Voucher.docx (interim).
 *   · 주주별 값(이름·주소·배당번호·주식수·받을 금액)은 mem_${id}/ 스코프.
 *   · 회사 공통 값(회사명·등록번호·등록사무소·총배당액·지급일·회계연도)은 <DocScope scope=""> 로 최상위 키에
 *     바로 묶는다 — voucher 마다 다시 입력하지 않고, 결의서(DR)의 값과 같은 칸이다.
 *   서명 = 이사 1인([[Signing_Director_Signature]]) → mem_${id}/signing_director_Signers.
 */
import CddVarField from '../../final-dividends/cdd/CddVarField.vue';
import AgmSigners from '../../final-dividends/cdd/AgmSigners.vue';
import DocScope from '../../final-dividends/cdd/DocScope.vue';
import '../../final-dividends/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <DocScope scope="">
      <div class="doc-head">
        <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
        <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
        <div>(Incorporated in the Republic of Singapore)</div>
        <div>(the &ldquo;Company&rdquo;)</div>
        <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
      </div>
    </DocScope>

    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Dividend No.</td><td><CddVarField field-key="dividend_number" label="Dividend Number" /></td>
          <td class="cdd-lcell">Date</td>
          <td><DocScope scope=""><CddVarField field-key="payment_date" label="Payment Date" /></DocScope></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p">
      <CddVarField field-key="member_name" label="Member Name" /><br />
      <CddVarField field-key="member_address" label="Member Address" />
    </p>
    <p class="doc-p">Dear Sir/Madam,</p>
    <DocScope scope="">
      <p class="doc-p">
        We are pleased to advise that an interim dividend of
        <CddVarField field-key="total_dividend_amount" label="Total Dividend Amount" />
        under One-Tier Corporate Tax System has been declared out of profits of the company, for the financial year ending
        <CddVarField field-key="financial_year_end" label="Financial Year End" />.
      </p>
      <p class="doc-p">
        The amount due in respect of the shares registered in your name as of
        <CddVarField field-key="payment_date" label="Payment Date" /> is as follows:
      </p>
    </DocScope>

    <table class="cdd-tbl">
      <tbody>
        <tr><td>Dividend on <CddVarField field-key="number_of_shares" label="Number of Shares" /> ordinary shares</td><td><CddVarField field-key="amount_to_receive" label="Amount To Receive" /></td></tr>
        <tr><td>Less: Singapore Income Tax</td><td></td></tr>
        <tr><td>Tax Exempt (one-tier)</td><td></td></tr>
        <tr><td><b>Amount Due</b></td><td><CddVarField field-key="amount_to_receive" label="Amount To Receive" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">Yours faithfully,</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>

    <p class="doc-note">
      NOTE:<br />
      This notice constitutes the certificate required under the Income Tax Legislation and should be carefully preserved as only this
      original will be accepted by the Income Tax authorities in connection with any claim to allowance or relief from Income Tax.<br />
      Please notify of any change of address.
    </p>
  </div>
</template>
